import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLibrary: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLibrary"><Path fillRule="evenodd" clipRule="evenodd" d="M13.1224 2.75684L21.2431 20.6224L19.8776 21.2431L11.7569 3.37754L13.1224 2.75684ZM4.5 2.99996V21H3V2.99996H4.5ZM9.5 2.99996V21H8V2.99996H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLibrary;
